import { Button } from "react-bootstrap";
import { Dash, Plus } from "react-bootstrap-icons";
import { Link, useLocation } from "react-router-dom";

export interface ExpandToggleIconProps {
  isExpanded: boolean;
  purchaseOrderItemId: number;
}

export function ExpandToggleIcon({
  isExpanded,
  purchaseOrderItemId,
}: ExpandToggleIconProps) {
  const location = useLocation();

  return !isExpanded ? (
    <Link to={`purchaseOrderItem/${purchaseOrderItemId}${location.search}`}>
      <Button variant="light">
        <Plus />
      </Button>
    </Link>
  ) : (
    // "." goes up one level
    <Link to={`./${location.search}`}>
      <Button variant="light">
        <Dash />
      </Button>
    </Link>
  );
}
